import Icon from '@/components/icon';
import PublicServiceButton from '@/components/public-service-button';
import Tooltip from '@/components/tooltip';
import { Stack } from '@mui/material';
import MonitorSwitch from './monitor-switch';
import { FC, memo, MouseEvent } from 'react';
import { PublicServiceMeta } from '@/lib/models/public-service/public-service.model';

interface Props {
  isAllowList: boolean;
  isMonitor: boolean;
  isAllow: boolean;
  disabled: boolean;
  publicService: PublicServiceMeta;
  handleView: (event: MouseEvent, publicService: PublicServiceMeta) => void;
  onSwitchChange: (serviceId: string) => void;
}

const getServiceDisabledTooltip = (isAllowList: boolean): string =>
  isAllowList
    ? 'This service is on the block list and cannot be allowed.'
    : 'This service is on the allow list and cannot be blocked.';

const ServiceLabel: FC<Props> = ({
  isAllowList,
  disabled,
  publicService,
  handleView,
  onSwitchChange,
  isMonitor,
  isAllow,
}) => {
  const tooltipTitle = getServiceDisabledTooltip(isAllowList);
  const { id: serviceId } = publicService;

  return (
    <Tooltip title={tooltipTitle} disabled={!disabled}>
      <Stack direction="row" alignItems="center" width="100%" gap={1}>
        {disabled && <Icon name="lock" size="small" color="grey" />}
        <PublicServiceButton publicService={publicService} onInfoClick={handleView} noDetails />

        {isAllowList && isAllow && (
          <MonitorSwitch value={isMonitor} onChange={() => onSwitchChange(serviceId)} />
        )}
      </Stack>
    </Tooltip>
  );
};

export default memo(ServiceLabel);
